import {ApplicationConfig, LOCALE_ID, provideZonelessChangeDetection, provideAppInitializer, inject} from '@angular/core';
import {provideRouter, RouteReuseStrategy} from '@angular/router';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {provideServiceWorker} from '@angular/service-worker';
import {provideIonicAngular, IonicRouteStrategy} from '@ionic/angular/standalone';
import {registerLocaleData} from '@angular/common';
import {LocalStorageService} from './services/storage.service';
import {environment} from '../environments/environment';
import {routes} from './app.routes';
import {appInterceptor} from './app.interceptor';
import {StorageService} from '@kilobytelab/core';
import {API_URL_TOKEN} from '@kilobytelab/domain';

/*** ICONOS ***/
// --- REGISTRO DE ICONOS IONIC ---
import {addIcons} from 'ionicons';
import {
  closeCircle, arrowBackCircleOutline, arrowForwardCircleOutline, documentText, person, cloudUpload, cloudDownloadOutline,
  shareOutline, closeOutline, locationOutline, chevronBackOutline, chevronForwardOutline, timeOutline, checkboxOutline,
  notificationsSharp, notificationsOffSharp, logoPwa, logoWhatsapp, at, globe, mail, mailOpen, alertCircle, caretDown, call,
  chevronForward, chatbubbleEllipsesOutline, checkmarkCircle, trash, images, checkmarkOutline, chevronForwardCircleSharp,
  returnDownForwardOutline, heart, fileTrayFullOutline, calendarOutline, shieldCheckmarkOutline, menu, refreshOutline, easel,
  logOutOutline, radioOutline, libraryOutline, imagesOutline, chatbubblesOutline, reload, mailOutline, callOutline, sunny,
  checkmarkDoneCircle, cardOutline, logoFacebook, logoInstagram, documentsOutline, walletOutline, restaurantOutline, arrowBack,
  arrowBackCircle, arrowForwardCircle
} from 'ionicons/icons';
addIcons({
  closeCircle, arrowBackCircleOutline, arrowForwardCircleOutline, documentText, person, cloudUpload, cloudDownloadOutline,
  shareOutline, closeOutline, locationOutline, chevronBackOutline, chevronForwardOutline, timeOutline, checkboxOutline, heart,
  notificationsSharp, notificationsOffSharp, logoPwa, logoWhatsapp, at, globe, mail, mailOpen, alertCircle, caretDown, call,
  chevronForward, chatbubbleEllipsesOutline, checkmarkCircle, trash, images, checkmarkOutline, chevronForwardCircleSharp,
  returnDownForwardOutline, fileTrayFullOutline, calendarOutline, shieldCheckmarkOutline, menu, refreshOutline, logOutOutline,
  radioOutline, libraryOutline, imagesOutline, chatbubblesOutline, reload, mailOutline, callOutline, sunny, easel, checkmarkDoneCircle,
  cardOutline, logoFacebook, logoInstagram, documentsOutline, walletOutline, restaurantOutline, arrowBack, arrowBackCircle,
  arrowForwardCircle
});
import {provideIcons} from '@ng-icons/core';
import {
  matOpenInNew, matFileDownload, matIosShare, matSmartDisplay, matInfo, matAssignmentInd, matDining,
  matCoPresent, matCampaign
} from '@ng-icons/material-icons/baseline';
import {tablerSettingsExclamation, tablerTaxEuro, tablerCoinEuro, tablerVideo, tablerVideoOff, tablerRefresh} from '@ng-icons/tabler-icons';
/*** ***/

// --- CONFIGURACIÓN REGIONAL ---
import localeEs from '@angular/common/locales/es';
import {Settings} from 'luxon';
registerLocaleData(localeEs, 'es');
Settings.defaultLocale = 'es';

async function verificarCacheInicial() {
  const storage = inject(StorageService);
  const localStrgService = inject(LocalStorageService);
  const VERSION_ESTRUCTURAL = 'v2_zoneless';
  try {
    const versionActual = window.localStorage.getItem('app_structure_version');
    if (versionActual !== VERSION_ESTRUCTURAL) {
      console.warn('Nueva estructura detectada. Salvando credenciales y limpiando caché antigua...');
      const tokenUsuario = await storage.getToken();
      const tokenPush = await localStrgService.getTokenPush();
      await storage.clearItems();
      sessionStorage.clear();
      if (tokenUsuario) {
        await storage.setToken(tokenUsuario);
      }
      if (tokenPush) {
        await localStrgService.setTokenPush(tokenPush);
      }
      window.localStorage.setItem('app_structure_version', VERSION_ESTRUCTURAL);
      window.location.reload();
      return
    }
  } catch (e) {
    console.error('Error temporal leyendo caché en el arranque, omitiendo limpieza:', e)
  }
}

// --- EXPORTACIÓN DE LA CONFIGURACIÓN ---
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    provideZonelessChangeDetection(),
    provideIonicAngular({innerHTMLTemplatesEnabled: true}),
    {provide: LOCALE_ID, useValue: 'es'},
    {provide: API_URL_TOKEN, useValue: environment.apiUrl},
    provideHttpClient(withInterceptors([appInterceptor])),
    provideServiceWorker('/combined-sw.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000'
    }),
    provideAppInitializer(verificarCacheInicial),
    provideIcons({
      matOpenInNew, matFileDownload, matIosShare, tablerSettingsExclamation, tablerTaxEuro, tablerCoinEuro, matSmartDisplay, matInfo,
      matAssignmentInd, matDining, matCoPresent, matCampaign, tablerVideo, tablerVideoOff, tablerRefresh
    })
  ]
};